import { render, staticRenderFns } from "./ResetPassword-v1.vue?vue&type=template&id=5a080b8c"
import script from "./ResetPassword-v1.vue?vue&type=script&lang=js"
export * from "./ResetPassword-v1.vue?vue&type=script&lang=js"
import style0 from "./ResetPassword-v1.vue?vue&type=style&index=0&id=5a080b8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports